import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=0571aa84&scoped=true&"
import script from "./Statement.vue?vue&type=script&lang=js&"
export * from "./Statement.vue?vue&type=script&lang=js&"
import style0 from "./Statement.vue?vue&type=style&index=0&id=0571aa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571aa84",
  null
  
)

export default component.exports
import {QPage,QSpinnerDots,QCard,QCardSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QPage,QSpinnerDots,QCard,QCardSection,QItemLabel}, component.options.components || {})
